import { AdPlacement } from '@openx/types/adUnit.ts';
import type { OptionsMap } from '@openx/types/options.ts';

export const mapAdPlacementLabels = (inputValue: AdPlacement, adPlacement: OptionsMap): string | null => {
  switch (inputValue) {
    case AdPlacement.Banner:
      return adPlacement.BANNER?.name;
    case AdPlacement.Video:
      return adPlacement.VIDEO?.name;
    case AdPlacement.Native:
      return adPlacement.NATIVE?.name || 'NATIVE';
    case AdPlacement.CTV:
      return adPlacement.CTV?.name || 'CTV';
    case 'BANNER,VIDEO' as AdPlacement:
      return 'Any (Banner or Video)';
    default:
      return null;
  }
};
